import { styled } from '@mui/material/styles'

export const StyledContainer = styled('div')({
  width: 40,
  height: 40,
  borderRadius: '50%',
  marginRight: 16,
})
